export default __webpack_public_path__ + "static/grey-2dc7d70051aff02c0b91f227f4b6877d.png";